
export const environment = {
    name: 'production',
    production: true,
    froalaLicenseKey: 'ETdabH-8a2A3wD4D3B1F1H5A3nDc2YRTYKg1Dc2a1JVVG1VJKKYLMPvA1E1I1B1B8D7C7E1D5F4==',
    froalaEditorKey: 'GPD2tA17B8B1C2D2C1sGXh1WWTDSGXYOUKc1KINLe1OC1c1D-17D2E2F2A1E4G1A3B8D7E6==',
    frontUrl  : 'https://i.snoball.it/#',
    apiUrl: 'https://api.snoball.it',
    websocket: 'wss://api.snoball.it',
    sentryDsn: 'https://1e7db1a693f6a905d4970f1319ea7a96@o4506535739981824.ingest.us.sentry.io/4508558685765632'
};
